const TALENT_RANK_TITLES = [
  'talent rank',
  'talent category',
  'override talent rank (optional)',
  'override talent category (optional)',
]

export const isTalentRankTitle = (title?: string): boolean => {
  if (!title) {
    return false
  }

  return TALENT_RANK_TITLES.includes(title.trim().toLowerCase())
}
